import { CSSProperties } from 'react';
import styles from '../devicePng/devicePng.module.scss';

const cpTu_cone_CLASS = 'CPTU_CONE';
const kompura_CLASS = 'COMPRESSOR';
const siipikaira_CLASS = 'VANE_APPARATUS';
const rod_CLASS = 'ROD';
const Geotanko_TYPE = 'PORATANKO'; //'GEOTANKO';
const Iskuputki_TYPE = 'ISKUPUTKI';
const Kairatanko_TYPE = 'KAIRATANKO';
const positioning_device_CLASS = 'POSITIONING_DEVICE';

let geotanko = require('../../../resources/icon/equipments/equipmentsPng/Geotanko.png');
let iskuputki = require('../../../resources/icon/equipments/equipmentsPng/Iskuputki.png');
let kairatanko = require('../../../resources/icon/equipments/equipmentsPng/Kairatanko.png');
let kompura = require('../../../resources/icon/equipments/equipmentsPng/kompura.png');
let siipikaira = require('../../../resources/icon/equipments/equipmentsPng/siipikaira.png');
let cptuCone = require('../../../resources/icon/equipments/equipmentsPng/gm-ctpu.png');
let equipmentDefault = require('../../../resources/icon/equipments/equipmentsPng/equipment.png');

export const getEquipmentImagePng = (
    equipment: any,
    style?: CSSProperties,
    nameClass?: string,
    nameType?: string
): React.FunctionComponent => {
    let EquipmentClass = equipment && equipment.EquipmentClass ? equipment.EquipmentClass : null;
    const className = nameClass
        ? `${nameClass}`
        : EquipmentClass && EquipmentClass.Name
        ? EquipmentClass.Name.toUpperCase()
        : '';

    const EquipmentType = equipment && equipment.EquipmentType ? equipment.EquipmentType : null;
    const typeName = nameType
        ? `${nameType.toUpperCase()}`
        : EquipmentType && EquipmentType.Name
        ? EquipmentType.Name.toUpperCase()
        : '';

    let maskRules = 'center center / contain no-repeat';
    if (className === rod_CLASS) {
        switch (typeName) {
            case Geotanko_TYPE:
                // return Geotanko;
                return () => (
                    <div
                        style={{
                            mask: `url(${geotanko}) ${maskRules}`,
                            WebkitMask: `url(${geotanko}) ${maskRules}`,
                            ...style
                        }}
                        className={styles.masking}
                    ></div>
                );
            case Iskuputki_TYPE:
                return () => (
                    <div
                        style={{
                            mask: `url(${iskuputki}) ${maskRules}`,
                            WebkitMask: `url(${iskuputki}) ${maskRules}`,
                            ...style
                        }}
                        className={styles.masking}
                    ></div>
                );
            case Kairatanko_TYPE:
                return () => (
                    <div
                        style={{
                            mask: `url(${kairatanko}) ${maskRules}`,
                            WebkitMask: `url(${kairatanko}) ${maskRules}`,
                            ...style
                        }}
                        className={styles.masking}
                    ></div>
                );
            default:
                return () => (
                    <div
                        style={{
                            mask: `url(${equipmentDefault}) ${maskRules}`,
                            WebkitMask: `url(${equipmentDefault}) ${maskRules}`,
                            ...style
                        }}
                        className={styles.masking}
                    ></div>
                );
        }
    } else {
        switch (className) {
            case cpTu_cone_CLASS:
                return () => (
                    <div
                        style={{
                            mask: `url(${cptuCone}) ${maskRules}`,
                            WebkitMask: `url(${cptuCone}) ${maskRules}`,
                            ...style
                        }}
                        className={styles.masking}
                    ></div>
                );
            case kompura_CLASS:
                return () => (
                    <div
                        style={{
                            mask: `url(${kompura}) ${maskRules}`,
                            WebkitMask: `url(${kompura}) ${maskRules}`,
                            ...style
                        }}
                        className={styles.masking}
                    ></div>
                );
            case siipikaira_CLASS:
                return () => (
                    <div
                        style={{
                            mask: `url(${siipikaira}) ${maskRules}`,
                            WebkitMask: `url(${siipikaira}) ${maskRules}`,
                            ...style
                        }}
                        className={styles.masking}
                    ></div>
                );
            case positioning_device_CLASS:
            default:
                return () => (
                    <div
                        style={{
                            mask: `url(${equipmentDefault}) ${maskRules}`,
                            WebkitMask: `url(${equipmentDefault}) ${maskRules}`,
                            ...style
                        }}
                        className={styles.masking}
                    ></div>
                );
        }
    }
};
